// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2nG2f","content":"ManualTimeModal_content__1fjwA"};